import { lazy } from "react";
import { Navigate, RouteObject } from "react-router-dom";

const AgentBilling = lazy(() => import("@/pages/admin/billing/AgentBilling/AgentBilling"));
const NewCharge = lazy(() => import("@/pages/admin/billing/NewCharge/NewCharge"));
const Invoices = lazy(() => import("@/pages/admin/billing/Invoices/Invoices"));
const MonthlyBilling = lazy(() => import("@/pages/admin/billing/Monthly/MonthlyBilling"));
const RecurringCharges = lazy(() => import("@/pages/admin/billing/RecurringCharges/RecurringCharges"));
const BillingReports = lazy(() => import("@/pages/admin/billing/Reports/BillingReports"));
// The Conference Archive invoice viewer works for any PB invoice, so billing reuses it
const BillingInvoice = lazy(() => import("@/pages/admin/ConferenceArchive/Invoices/InvoiceDetail/InvoiceDetail"));

const billingRoutes: RouteObject[] = [
  { index: true, element: <Navigate to="invoices" replace /> },
  { path: "agent", element: <AgentBilling /> },
  { path: "new-charge", element: <NewCharge /> },
  {
    path: "invoices",
    children: [
      { index: true, element: <Invoices /> },
      { path: ":id", element: <BillingInvoice /> },
    ],
  },
  { path: "monthly", element: <MonthlyBilling /> },
  { path: "recurring-charges", element: <RecurringCharges /> },
  { path: "reports", element: <BillingReports /> },
];

export default billingRoutes;
